/* eslint-disable i18next/no-literal-string */
import { Icons } from '@/app/components/ui/Icons'
import classNames from 'classnames'
import { capitalize } from 'lodash'
import { FC } from 'react'

interface CounterInputProps {
	label: string
	count: number
	min?: number
	max?: number
	disabled?: boolean
	isChildInput?: boolean
	disableIncrement?: boolean
	onCountChange: (count: number) => void
}

const b = 'guest-counter'
const CounterInput: FC<CounterInputProps> = ({
	label,
	count,
	min = 0,
	max,
	isChildInput,
	disabled = false,
	disableIncrement = false,
	onCountChange,
}) => {
	const decrementCount = () => {
		if (count > min) {
			onCountChange(count - 1)
		}
	}

	const incrementCount = () => {
		if (max === undefined || count < max) {
			onCountChange(count + 1)
		}
	}

	const isDecrementDisabled = count <= min
	const isIncrementDisabled =
		disabled || (max !== undefined && count >= max) || disableIncrement

	return (
		<div className={`${b}__input`}>
			<div className={`${b}__input-label`}>
				<p className="leading-5">{capitalize(label)}</p>
				{isChildInput && <p className="children ms-1">0-17</p>}
			</div>
			<div className={`${b}__controls`}>
				<button
					className={classNames(`${b}__button`, {
						[`${b}__button--disabled`]: isDecrementDisabled,
					})}
					onClick={decrementCount}
					disabled={isDecrementDisabled}
					data-test-id="guest-counter-decrement"
				>
					<Icons.minus />
				</button>
				<div className={`${b}__count`}>{count}</div>
				<button
					className={classNames(`${b}__button`, {
						[`${b}__button--disabled`]: isIncrementDisabled,
					})}
					onClick={incrementCount}
					disabled={isIncrementDisabled}
					data-test-id="guest-counter-increment"
				>
					<Icons.plus />
				</button>
			</div>
		</div>
	)
}

export default CounterInput
